import { ContactCreateParams, GeocodeContext, Program } from '@citruscamps/citrus-client'
import { Address } from '../../../../../utils/address'
import { MappedFieldInput } from '../components/ContactMatchStep'

export const formatMergeFields = (countryShortCode: string | undefined): Record<string, string> => {
  let region: string
  let postcode: string
  let country: string
  if (countryShortCode?.toLowerCase() === 'ca') {
    region = 'Province or territory'
    postcode = 'Postal code'
    country = 'Country'
  } else if (countryShortCode?.toLowerCase() === 'us') {
    region = 'State'
    postcode = 'Zip code'
    country = 'Country'
  } else {
    region = 'Region'
    postcode = 'Postal code'
    country = 'Country or Region'
  }
  return {
    'customer.email': 'Email address',
    'customer.first_name': 'First name',
    'customer.last_name': 'Last name',
    'customer.phone': 'Phone number',
    'customer.address_line_1': 'Street address',
    'customer.address_line_2': 'Apartment or Suite',
    'customer.city': 'City',
    'customer.region': region,
    'customer.postcode': postcode,
    'customer.country': country,
  }
}
export const mappedFieldsToContacts = (
  fields: MappedFieldInput[],
  program: Program,
  { countries, regions }: { countries?: GeocodeContext[]; regions?: GeocodeContext[] } = {},
): ContactCreateParams[] => {
  const address = program.address ? Address.fromGeocode(program.address) : undefined
  const contacts: ContactCreateParams[] = []
  fields.forEach((field) => {
    field.values.forEach((rawValue, i) => {
      const value = rawValue?.toString().trim()
      if (!contacts?.[i]) {
        contacts.push({} as ContactCreateParams)
      }
      if (field.merge_id && field.merge_id.includes('customer.phone')) {
        rawValue = rawValue ? `${rawValue}`.replace(/\D/g, '') : ''
        if (rawValue?.charAt(0) !== '1') {
          rawValue = `1${rawValue}`.trim()
        }
        contacts[i] = {
          ...(contacts[i] || {}),
          phones: rawValue ? [...(contacts[i].phones || []), rawValue] : contacts[i].phones || [],
          program_id: program.id,
        }
      } else if (
        field.merge_id &&
        (field.merge_id.includes('customer.address_line_1') ||
          field.merge_id.includes('customer.address_line_2') ||
          field.merge_id.includes('customer.city') ||
          field.merge_id.includes('customer.postcode'))
      ) {
        contacts[i] = {
          ...(contacts[i] || {}),
          addresses: rawValue
            ? [
                {
                  ...(contacts[i].addresses || [])?.[0],
                  [field.merge_id.split('.').pop() || '']: value,
                  source: 'custom',
                },
              ]
            : contacts[i].addresses || [],

          program_id: program.id,
        }
      } else if (field.merge_id && field.merge_id.includes('customer.region')) {
        const region: GeocodeContext | undefined = regions?.find(
          (r) =>
            r.text.toLowerCase() === rawValue?.toLowerCase()?.trim() ||
            (r.short_code && r.short_code?.toLowerCase().includes(rawValue?.toLowerCase()?.trim())),
        )
        contacts[i] = {
          ...(contacts[i] || {}),
          ...(!region?.short_code
            ? {
                [field.merge_id.split('.').pop() || '']: value,
              }
            : {}),
          addresses:
            rawValue && region?.short_code
              ? [
                  {
                    ...(contacts[i].addresses || [])?.[0],
                    region_short_code: region.short_code,
                    region: region.text,
                    source: 'custom',
                  },
                ]
              : contacts[i].addresses || [],
          program_id: program.id,
        }
      } else if (field.merge_id && field.merge_id.includes('customer.country')) {
        const country = countries?.find(
          (c) =>
            c.text.toLowerCase() === rawValue?.toLowerCase()?.trim() ||
            (c.short_code && c.short_code?.toLowerCase() === rawValue?.toLowerCase()?.trim()),
        )
        contacts[i] = {
          ...(contacts[i] || {}),
          ...(!country?.short_code
            ? {
                [field.merge_id.split('.').pop() || '']: value,
              }
            : {}),
          addresses:
            rawValue && country?.short_code
              ? [
                  {
                    ...(contacts[i].addresses || [])?.[0],
                    country_short_code: country.short_code,
                    country: country.text,
                    source: 'custom',
                  },
                ]
              : contacts[i].addresses || [],
          program_id: program.id,
        }
      } else if (
        field.merge_id &&
        Object.keys(formatMergeFields(address?.country_short_code)).includes(field.merge_id) &&
        field.merge_id.includes('customer.')
      ) {
        contacts[i] = {
          ...(contacts[i] || {}),
          timezone: program.timezone,
          [field.merge_id.split('.').pop() || '']: value,
          program_id: program.id,
        }
      } else {
        contacts[i] = {
          ...(contacts[i] || {}),
          timezone: program.timezone,
          properties: {
            ...(contacts[i].properties || {}),
            ...(field.merge_id ? { [field.merge_id || field.mapped_id]: value } : {}),
          },
          program_id: program.id,
        }
      }
    })
  })
  return contacts
}
